/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import moment from "moment";
import { ConfigProvider } from "antd";
import zhCN from "antd/lib/locale-provider/zh_CN";
import enUS from "antd/es/locale-provider/en_US";
import esES from "antd/es/locale-provider/es_ES";
import ZH_CN from "@/locale/zh-CN.messages";
import ES_ES from "@/locale/es-ES.messages";
import EN_US from "@/locale/en-US.messages";
import zh from "react-intl/locale-data/zh";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import { Provider } from "react-redux";
import { addLocaleData, IntlProvider } from "react-intl";
import PropTypes from "prop-types";
import BrowserLogger from "alife-logger";
import dashboardRoutes from "./routes/dashboard";
import Tool from "./utils/Tool";
import initStore from "./state/storeBus";
import "./doc/assets/css/material-dashboard-react.css";
import "./assets/stylus/base.styl";
import "./assets/stylus/micro-app.styl";

const __bl = BrowserLogger.singleton({
  pid: "gmpgmsbi3k@43cad529ddcedef",
  appType: "web",
  imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
  sendResource: true,
  enableLinkTrace: true,
  behavior: true,
  disableHook: true,
  enableSPA: true,
  useFmp: true,
});

// test
const switchRoutes = (
  <Switch>
    {dashboardRoutes.map((prop, key) => {
      if (prop.redirect) {
        return <Redirect from={prop.path} to={prop.to} key={key} />;
      }
      return <Route path={prop.path} component={prop.component} key={key} />;
    })}
  </Switch>
);

addLocaleData([...zh, ...en, ...es]);
class App extends Component {
  static childContextTypes = {
    store: PropTypes.object,
  };

  constructor(props) {
    super(props);
    // 初始化状态管理
    this.store = initStore();
    if (Tool.getUrlParam("token")) {
      window.sessionStorage.setItem("token", Tool.getUrlParam("token"));
    }
    if (Tool.getUrlParam("name")) {
      window.sessionStorage.setItem("name", Tool.getUrlParam("name"));
    }
    if (Tool.getUrlParam("id")) {
      window.sessionStorage.setItem("userId", Tool.getUrlParam("id"));
    }

    this.state = {
      localeInfo: null,
    };

    this.store.subscribe(() => {
      this.localeInfo = this.setMessage();
      this.forceUpdate();
    });
  }

  getChildContext() {
    return {
      store: this.store,
    };
  }

  setMessage = () => {
    // const locale = this.store.getState().appLocalInfo.locale;
    const locale = "zh";

    window.sessionStorage.setItem("locale", locale);
    let messages = null;
    let configLocale = null;

    // 判断locale值
    if (locale === "zh") {
      messages = ZH_CN;
      configLocale = zhCN;
    } else if (locale === "en") {
      messages = EN_US;
      configLocale = enUS;
    } else if (locale === "es") {
      messages = ES_ES;
      configLocale = esES;
    }
    if (locale === "zh") {
      moment.locale("zh-cn");
    }

    const LocaleInfo = {
      locale: locale,
      messages: messages,
      configLocale: configLocale,
    };

    return LocaleInfo;
  };

  render() {
    this.localeInfo = this.setMessage();

    const routerDom = (
      <Provider store={this.store}>
        <ConfigProvider locale={this.localeInfo.configLocale}>
          <IntlProvider locale={this.localeInfo.locale} messages={this.localeInfo.messages}>
            <div className="sc-oms-container">{switchRoutes}</div>
          </IntlProvider>
        </ConfigProvider>
      </Provider>
    );
    return routerDom;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/AntD/App.js